import * as R from 'ramda';

import { Icon } from '@atom/mui';
import { CategoryIcon } from '@atom/mui/icons';
import { FavoriteDetail, FavoriteSubjectType } from '@atom/types/favorite';
import schemaUtilities from '@atom/utilities/schemaUtilities';

import UserThumbnail from '../UserThumbnail';

export interface Props {
  subjectType: FavoriteSubjectType;
  favorite: FavoriteDetail;
}

const styles = {
  icon: {
    marginRight: '0.5rem',
  },
};

const FavoriteItemIcon = ({ subjectType, favorite }: Props) => {
  if (subjectType === 'USER') {
    return (
      <div style={styles.icon}>
        <UserThumbnail image={favorite?.photoUrl} alt={favorite?.firstName} />
      </div>
    );
  }

  const showSchemaIcon = !R.isNil(favorite?.locationType);

  if (showSchemaIcon) {
    return (
      <img
        style={styles.icon}
        alt=""
        src={schemaUtilities.getSchemaIconFromMarkerId(favorite?.markerId)}
      />
    );
  }

  return (
    <Icon
      color={schemaUtilities.getSchemaColorFromColorId(favorite?.colorId)}
      style={styles.icon}
      icon={CategoryIcon}
    />
  );
};

export default FavoriteItemIcon;
